<template>
  <div class="project-introduction">
    <!-- <div class="content">
    </div> -->
    <div class="centerContent">
      <el-breadcrumb separator="/">
<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
<el-breadcrumb-item >文件下载</el-breadcrumb-item>
</el-breadcrumb>
<div class="newsListContent">
<div class="newsList">
  <div class="newsItem" v-for="news in newsList" @click="goToNoticeDetail(news.id)">
      <div class="newsItemTitle title">{{news.title}}</div>
      <div class="newsItemTitle">{{news.add_date}}</div>
  </div>
</div>
<div class="paginBox">
            <div class="countNumber">
              共{{ count }}条
            </div>
            <div class="rightPagin">
              <el-pagination @size-change="sizePagination" @current-change="currentPagination"
                :page-size="filters.pageSize" background layout="prev, pager, next" :total="count">
              </el-pagination>
            </div>

          </div>
</div>
    </div>
  </div>
</template>

<script>

export default {
  name: "News",
  data() {
    return {
      newsList: [],
      count: 0,
      filters: {
        identify: 3,
        pageSize: 15,
        currPage: 1
      }
    }
  },
  mounted(){
    this.getNews()
  },
  methods: {
    sizePagination(e) {
    this.filters.currPage = e
    this.getNews()
  },
  currentPagination(e) {
    this.filters.currPage = e
    this.getNews()
  },
  goToNoticeDetail(id){
    this.$router.push({ path: "/FileDownloadDetail", query: { id: id }});
  },
  getNews(){
      this.$API.getNewsList(this.filters).then(res => {
        this.count = res.data.pageInfo.allRows;
        this.newsList = res.data.list;
      })
    },

  }

};
</script>

<style scoped  lang='less'>
.countNumber {
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #515A6E;
}
.paginBox {
display: flex;
justify-content: end;
padding: 0 20px 20px 0;
align-items: center;
margin-top: 20px;
width: 100%;
}

::v-deep .el-pagination.is-background .btn-prev {
background: none;
}

::v-deep .el-pagination .btn-next .el-icon {
font-size: 18px;
}

::v-deep .el-pagination .btn-prev .el-icon {
font-size: 18px;
}

::v-deep .btn-next {
width: 36px;
height: 36px;
background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}

::v-deep .btn-prev {
width: 36px;
height: 36px;
background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
background: #FFFFFF;
border-radius: 3px 3px 3px 3px;
border: 1px solid #2F86FF;
font-weight: 400;
font-size: 14px;
color: #2F86FF;
text-align: center;
font-style: normal;
text-transform: none;
}

::v-deep .el-pagination.is-background .el-pager li {
border-radius: 3px 3px 3px 3px;
border: 1px solid #B4B4B4;
background: none;
width: 36px;
height: 36px;
font-weight: 400;
font-size: 14px;
color: #313131;
text-align: center;
font-style: normal;
text-transform: none;
line-height: 35px;
}
.title:hover{
  cursor: pointer;
  color: #2f86ff;
}
.newsItemTitle{
  color: #000000a6;
  font-size: 14px;
}
.newsItem{
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid #e8e8e8;
}
.newsList{
  padding: 0 50px;
}
.newsListContent{
  background: #fff;
  margin-top: 30px;
}
::v-deep .is-link{
  color: #00000073;
}
.centerContent{
  width: 1200px;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 30px;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: center;
  justify-content: center;
  background-color: #eeeeee;
}
.project-introduction {
  background: #eeeeee;
}
.content{
  position: relative;
  z-index: 2;
  overflow: hidden;
  background: #000;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
  background-image: url('../../assets/fileDownload.png');
  background-repeat: no-repeat;
  background-position: 50%;
  width: 100%;
  min-height: 350px;
  -webkit-align-items: center;
  align-items: center;
}
</style>
